import type { CoursesAdminUpdateSiteVideoDto } from '@sportspredict/shared';
import type { Wire } from '../../types/common.types';
import { coursesApi } from './courses-base.api';
import type {
	GetDashboardControlsOutput,
	UpdateSiteVideoInput,
	UpdateSiteVideoOutput,
} from '../../types/admin-controls.types';

const TAG = 'courses:admin-controls' as const;
const INVALIDATES = [TAG, 'courses:dashboard'] as const;

export const adminControlsEndpoints = coursesApi.injectEndpoints({
	endpoints: (builder) => ({
		getDashboardControls: builder.query<GetDashboardControlsOutput, void>({
			query: () => ({ url: 'courses/admin/platform/dashboard-controls' }),
			providesTags: [TAG],
		}),
		updateSiteVideo: builder.mutation<UpdateSiteVideoOutput, UpdateSiteVideoInput>({
			query: (body) => ({
				url: 'courses/admin/platform/site-video',
				method: 'PUT',
				body: body satisfies Wire<CoursesAdminUpdateSiteVideoDto>,
			}),
			invalidatesTags: [...INVALIDATES],
		}),
	}),
});

export const {
	useGetDashboardControlsQuery,
	useLazyGetDashboardControlsQuery,
	useUpdateSiteVideoMutation,
} = adminControlsEndpoints;
